import { HStack, Text, Tooltip, useMediaQuery } from '@chakra-ui/react'
import Image from 'next/image'

export type BenefitsSizes = 'default' | 'large'

export interface BenefitsProps {
  icon: string
  title: string
  description?: string
  size?: BenefitsSizes
}

const sizes: Record<BenefitsSizes, any> = {
  default: {
    hStack: {
      paddingX: '0.5rem',
      height: '1.5rem',
      borderColor: 'gray.400',
    },
    icon: {
      width: '24px',
      height: '24px',
    },
    text: {
      fontSize: '0.625rem',
    },
  },
  large: {
    hStack: {
      paddingY: '0.25rem',
      paddingX: '1rem',
      borderColor: 'gray.700',
    },
    icon: {
      width: '32px',
      height: '32px',
    },
    text: {
      fontSize: '1.125rem',
    },
  },
}

export const BenefitsProduct = ({ icon, title, description, size = 'default' }: BenefitsProps) => {
  const [isMobile] = useMediaQuery('(max-width: 426px)')
  const currentSize = isMobile ? sizes.default : sizes[size]

  return (
    <Tooltip label={description} isDisabled={!description}>
      <HStack
        justifyContent={'flex-start'}
        border="1px"
        borderColor="gray.400"
        borderRadius="2px"
        gridGap={'4px'}
        {...currentSize.hStack}
      >
        <Image src={icon} {...currentSize.icon} quality={100} />
        <Text color="gray.600" margin="0 !important" {...currentSize.text}>
          {title}
        </Text>
      </HStack>
    </Tooltip>
  )
}
